// Gatsby supports TypeScript natively!
import React from 'react';

import { Link } from 'gatsby';
import {
  GiModernCity,
  GiBullseye,
  GiDirectionSign,
  GiDna1,
  GiSatelliteCommunication,
} from 'react-icons/gi';
import { MdPhone, MdMailOutline } from 'react-icons/md';
import { AiFillDatabase } from 'react-icons/ai';

import {
  FaLinkedin,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaBlog,
  FaFacebook,
  FaNetworkWired,
} from 'react-icons/fa';
import Layout from '../components/layout';
import Section from '../components/Section';
import SEO from '../components/seo';
import Navbar from '../components/Navbar';
import Banner from '../components/Banner';
import Card from '../components/Card';

import Logo from '../images/e2ebranco.png';

import {
  HeroContainer,
  TopSection,
  FooterContainer,
  MiddleSection,
} from '../styles/about-us.styles';

const AboutUs = () => {
  return (
    <Layout>
      <SEO title="Sobre nós" />
      <TopSection>
        <Navbar>
          <Link to="/">
            <img src={Logo} alt="Logo" />
          </Link>
          <div>
            <Link to="/about-us">Sobre nós</Link>
            <a href="mailto:comercial@e2etecnologia.com">Contato</a>
          </div>
        </Navbar>
        <HeroContainer>
          <p>
            Produtos, serviços e soluções de grande performance, tecnologias de
            ponta garantindo estabilidade em sua conexão
          </p>
        </HeroContainer>
      </TopSection>
      <Section title="Sobre nós">
        <p style={{ lineHeight: 2, textAlign: 'center' }}>
          Da união de Executivos com ampla experiência no mercado de telecom,
          nasceu a End to End Tecnologia & Soluções (E2E), uma empresa
          brasileira com cobertura nacional, dedicada ao fornecimento de
          tecnologia e soluções em serviços gerenciados de telecomunicações,
          instalação, operação e manutenção de sistemas especiais
          (infraestrutura, segurança, automação, monitoramento e economia de
          energia). Atendemos a demanda dos mercados corporativo, Operadoras,
          Provedores de Serviços, Industrial, Hospitalar, Comercial, Financeiro,
          Turístico e Imobiliário em edifícios polivalentes. Contamos com corpo
          técnico qualificado e equipes multidisciplinar que viabilizam imediata
          possibilidade de ampliação da estrutura para atender novos contratos.
          Experiências, expertises e profissionais responsáveis que garantem a
          pontualidade e qualidade em todos os compromissos assumidos. Da rede
          de relacionamentos E2E, vieram contratos de exclusividade para o
          fornecimento de equipamentos de acesso à rede de banda larga de alta
          velocidade, alta qualidade, performance e estabilidade para nossos
          clientes com produtos e soluções personalizadas de acordo com a
          demanda final do mercado.
        </p>
      </Section>

      <MiddleSection />
      <Section>
        <Card
          icon={GiBullseye}
          title="MISSÃO"
          description="Atuar de forma responsável nas atividades desenvolvidas, fornecendo serviços e soluções de mais eficiente e conveniente, com maior qualidade e segurança, agregando agilidade, conhecimento e eficiência para garantir os resultados previstos e criar valor para os clientes."
        />
        <Card
          icon={GiDirectionSign}
          title="VISÃO"
          description="Estar posicionado no mercado entre as melhores empresas de Produtos, Serviços e soluções e demais áreas de atuação nos próximos anos."
        />
        <Card
          icon={GiDna1}
          title="VALORES"
          description="Seriedade e Ética, Inovação, Excelência dos Serviços, Responsabilidade Social e Ambiental e Alinhamento com foco nos melhores resultados para o cliente.
          Comunicação clara e precisa.
          Gestão consistente de equipes."
        />
      </Section>
      <Section title="Serviços">
        <div
          style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
        >
          <Banner
            id="telecomunicacoes"
            icon={FaNetworkWired}
            title="Telecomunicações"
            description="Atendemos a crescente demanda por comunicação de dados e voz, oferecendo as mais variadas soluções utilizando de nossas experiências no setor de Telecomunicações. A E2E atua junto às operadoras de Telefonia e fabricantes de equipamentos do mercado. Empresa pioneira no fornecimento e implantação de equipamentos da tecnologia WiFi 6, atua na ampliação e manutenção de estações rádio base, bem como na melhoria de qualidade de rede e área de cobertura de telefonia celular, tv a cabo e internet."
          >
            <ul>
              <li>Vistorias, Laudos e Projetos; </li>
              <li>Adequações de Infraestrutura Civil e Elétrica; </li>
              <li>Central de Comutação e Controle (MSC/RNC); </li>
              <li>Instalação de Equipamentos ERB (GSM, 3G, 4G, 5G); </li>
              <li>Instalação de Sistema Irradiante; </li>
              <li>Serviços de Drive / Walk Test; </li>
              <li>Projetos e Instalações de Cobertura Indoor; </li>
              <li>Integração e Comissionamento de Equipamentos;</li>
              <li>
                Transmissão MW (Site Survey, Path Survey, LOS, Projeto Sistêmico
                e Cálculo de Desempenho de Enlace);{' '}
              </li>
              <li>Serviços de acessos DSLAM (RedeFixa); </li>
              <li>
                Serviços de DATACOM; Serviços de ACESSO; Serviços de OPTIX.
              </li>
            </ul>
          </Banner>
          <Banner
            icon={GiModernCity}
            id="monitoramento"
            title="Monitoramento e Safety city"
            description="A área de monitoramento e Safety City, desenvolvemos soluções integradas e implantação completa, reforma ou modernização de sistemas de controle. Atuamos em todas as fases do projeto: levantamento, licenciamento, projetos, execução, treinamento, operação e manutenção."
          >
            <ul>
              <li> Projeto e Engenharia de redes (CAD / REVIT)</li>
              <li>Construção</li>
              <li>Consultoria</li>
              <li>Administração</li>
              <li>Manutenção</li>
              <li>Metálicos e cabeamento estruturado</li>
              <li>Sistema de televisão em circuito fechado (CCTV)</li>
              <li>Sistema de controle de acesso </li>
              <li>Sistema de intercomunicação</li>
              <li>Sistema de TV MDU</li>
              <li>Detecção e Notificação de Incêndio</li>
              <li>Alarme de intrusão</li>
              <li>Design de iluminação</li>
              <li>Automação residencial</li>
              <li>BMS (Sistema de Gestão Predial)</li>
            </ul>
          </Banner>
          <Banner
            id="dataCenters"
            icon={AiFillDatabase}
            title="Data Centers"
            description="A E2E suporta planos de negócios dos clientes na execução de estudos, projetos, gerenciamento, instalação, treinamento, operação e manutenção dos ambientes."
          >
            <ul>
              <li>Instalação em geral,</li>
              <li>Sistemas de energia,</li>
              <li>Sistemas de climatização (precisão),</li>
              <li>Cabeamento estruturado,</li>
              <li>
                Configuração e fornecimento de switches, cordões óticos, fibras,
              </li>
              <li>Sistemas de supervisão, controle e automação,</li>
              <li>
                Sistemas detecção e alarme, detecção precoce, combate com gás
                eágua
              </li>
              <li>Operação e manutenção</li>
            </ul>
          </Banner>

          <Banner
            id="fornecimento"
            icon={GiSatelliteCommunication}
            title="Fornecimento de Recursos Técnicos"
            description=" Alocação de recursos E2E une a estratégia do cliente em implementar
          temporariamente ou permanentemente uma solução que a especialidade
          requer, na velocidade e período necessários e que dê sustentação ao
          projeto. Ao identificar a necessidade deste apoio aos clientes, a E2E
          especializou-se em elaborar acordos e contratos benéficos, dando
          opções a garantir os melhores profissionais disponíveis no mercado,
          sem que eles possuam vínculo direto com estas empresas, seja por
          Outsourcing (SOW – Escopo técnico) ou Body Shop (ETL – Trabalho
          Temporário), alocamos profissionais competentes por tempo
          previsto/pré-determinado (ambos respeitando as rígidas regras de
          terceirização garantidas pela legislação vigente). As vantagens da
          alocação de recursos, eliminam a necessidade de se ter “vagas abertas”
          e recrutamento de profissionais no cliente, gerando alternativas para
          projetos e necessidades pontuais. Possibilitam redução de custos e
          encargos de contratações e demissões. Acompanham as demandas
          evolutivas de atividades do negócio e proporcionam velocidade no
          acesso de profissionais especializados em funções específicas. Os
          recursos E2E atendem ao desempenho de funções ou serviços que o
          cliente não tenha expertise, especialidade ou infraestrutura para
          executar, aumentando significativamente a rentabilidade de projetos.
          Uma equipe externa de consultores técnicos podem trazer benefícios
          imediatos no conhecimento e competências profissionais, proporcionando
          aconselhamento especializado e know-how aos projetos sem a necessidade
          de contratar uma equipe fixa para sua realização. O cliente define as
          qualificações e necessidades dos colaboradores aos quais serão
          exigidos requisitos técnicos para o projeto e a E2E buscará as
          melhores soluções."
          />
        </div>
      </Section>
      <Section background="#002D55">
        <FooterContainer>
          <div>
            <h2>Contatos:</h2>
            <p>
              <MdPhone size={24} /> +55 11 98237-0878
            </p>
            <p>
              <a href="mailto:comercial@e2etecnologia.com">
                <MdMailOutline size={24} /> comercial@e2etecnologia.com
              </a>
            </p>
          </div>
          <div>
            <h2>Redes sociais:</h2>
            <p>
              <a href="https://www.instagram.com/e2etecnologia/">
                <FaInstagram size={24} color="#FFFFFF" />
              </a>
              <a href="https://twitter.com/e2etecnologia">
                <FaTwitter size={24} color="#FFFFFF" />
              </a>
              <a href="https://e2etecnologia.blogspot.com/">
                <FaBlog size={24} color="#FFFFFF" />
              </a>
            </p>
            <p>
              <a href="https://www.linkedin.com/company/e2etecnologia/">
                <FaLinkedin size={24} color="#FFFFFF" />
              </a>
              <a href="https://www.youtube.com/channel/UCeJrzRjBxGVAyIUgz2uIirQ">
                <FaYoutube size={24} color="#FFFFFF" />
              </a>
              <a href="https://www.facebook.com/E2ETecnologia/">
                <FaFacebook size={24} color="#FFFFFF" />
              </a>
            </p>
          </div>
        </FooterContainer>
      </Section>
    </Layout>
  );
};

export default AboutUs;
